export type TerminationRequestStatus = 'p' | 'a' | 'r'

export interface TerminationRequest {
  id: string
  tenantCode: string
  workspaceCode: string
  workspaceName: string
  inactiveDate: string | null
  reason: string
  status: TerminationRequestStatus
  requestedBy: string
  requestedByName: string | null
  requestedByEmail: string | null
  requestedDate: string
  reviewedBy: string | null
  reviewedDate: string | null
  reviewComments: string | null
  notes: string | null
  permanentDeletionDate: string | null
}

export interface SubmitTerminationRequestRequest {
  tenantCode: string
  inactiveDate: string // 'YYYY-MM-DD'
  reason: string
  notes?: string
}

export interface TerminationRequestListResponse {
  data: TerminationRequest[]
}

export const TerminationRequestStatusLabels: Record<TerminationRequestStatus, string> = {
  p: 'Pending',
  a: 'Approved',
  r: 'Rejected'
}

export const TerminationRequestStatusColors: Record<TerminationRequestStatus, string> = {
  p: 'blue',
  a: 'green',
  r: 'red'
}
